import React from 'react';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../utils/translationDictionaries';
import './About.css';

const About = () => {
  const { language } = useLanguage();
  const { t } = useTranslations(language);

  return (
    <div className="about">
      <SEO 
        title="Acerca de Noemí Alicea González | Corredora Autorizada Puerto Rico | Alicea Realty Group LLC"
        description="Noemí Alicea González (Noemi Alicea), Lic. C-16344, Corredora Autorizada con más de 15 años de experiencia en bienes raíces en Puerto Rico. Presidenta Electa del Mid Island Association of REALTORS 2025. Certificaciones: ABR, GREEN, e-PRO, SFR, RENE, PSA, C2EX, AHWD."
        keywords="Noemí Alicea González, Noemi Alicea, Noemi Alicea Gonzalez, Alicea Realty Group, corredora autorizada Puerto Rico, realtor Puerto Rico, ABR, GREEN, e-PRO, SFR, RENE, PSA, C2EX, AHWD, Mid Island Association of REALTORS, MIAR, NAR, PRAR, HUD properties Puerto Rico, real estate broker Puerto Rico"
        ogTitle="Acerca de Noemí Alicea González | Corredora Autorizada Puerto Rico"
        ogDescription="Noemí Alicea González, Corredora Autorizada con más de 15 años de experiencia en bienes raíces en Puerto Rico. Presidenta Electa del Mid Island Association of REALTORS 2025."
        ogImage="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2FPicture3.png?alt=media&token=66d381c9-39fc-49f9-a322-8ac5389eac40"
        canonical="https://www.alicearealtypr.com/about"
        type="profile"
      />
      
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>{t('about.title')}</h1>
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Farg_logo_nobg.png?alt=media&token=53b347a3-8d9e-4e5a-8a1f-64b7cbc32e69" 
            alt="Alicea Realty Group LLC Logo"
            width="500"
            height="200"
          />
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>{t('about.mission')}</h2>
            <p>
              {t('about.missionText')}
            </p>
          </div>

          <div className="about-section">
            <h2>{t('about.vision')}</h2>
            <p>
              {t('about.visionText')}
            </p>
          </div>
          <div className="about-section">
            <h2>{t('about.values')}</h2>
            <p>
              {t('about.valuesText')}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
